// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SupportNewMessage_formContainer__1pQbl","formHolder":"SupportNewMessage_formHolder__2m_Ai"};